import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useMediaQuery, Grid } from "@material-ui/core";
import { SimpleLoading, ButtonHLPure } from "..";
import "./dialogYesNoHL.css";


const DialogYesNoHLPure = (props) => {
  const {
    cancel, //Function to open or close dialog
    textBtnCancel, //Text secondary button, string, example "Cancelar"
    saveBtn, //Text to primary button, string, example "Guardar"
    titleDialog, //Title dialog string
    loadingComponent, //Loading component
    handleSubmit, //Function to submit dialog
    saveError, //error true or false
    textBtnCancelDisabled, //true to disabled, false active
    saveBtnDisabled, //true to disabled, false active
    children, //Children, create to component body,
    btnCancel,
    handleCancel
  } = props;

  const matches = useMediaQuery("(max-width:820px)");
  // let dialogCollaboratorWidth = loadingComponent ? 590 : 600;
  // let dialogCollaboratorHeight = loadingComponent ? 430 : 560;

  // const [isLoading, setIsLoading] = useState(false);
  // const [visible, setVisible] = useState(false);

  //Function to open or close dialog
  // const toggleDialog = () => {
  //   setVisible(!visible);
  // };

  return (
    <Dialog
      className="dialogYesNoHLPure-container"
      title={titleDialog}
      onClose={(btnCancel)? () => handleCancel(false) :() => {cancel(false)}}
      width={matches ? 100 : 290}
      height={matches ? 150 : 300}
    >
      {loadingComponent && (
        <div>
          <SimpleLoading />
        </div>
      )}

      {!saveError && !loadingComponent && (
        <>
          {children}
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="dialogYesNoHLPure-btns-container"
          >
            <Grid className="dialogYesNoHLPure-btnCancel">
              <ButtonHLPure
                nameBtn={textBtnCancel}
                onClickBtn={() => {
                  cancel(false);
                }}
                primary={false}
                disabled={textBtnCancelDisabled}
              />
            </Grid>
            <ButtonHLPure
              primary={true}
              nameBtn={saveBtn}
              onClickBtn={() => handleSubmit()}
              disabled={saveBtnDisabled}
            />
          </Grid>
        </>
      )}
    </Dialog>
  );
};

export { DialogYesNoHLPure as default };
